export default {
  FARMSTAND: 'FARMSTAND',
  PLANT: 'PLANT',
  OTHER: 'OTHER',
  EXTENSION: 'EXTENSION',
  GLOW_RING: 'GLOW_RING',
  DOLLY: 'DOLLY',
};
